import { SvgIcon } from '@mui/material';

/** Logo do Windows (quatro painéis). */
export function WindowsLogoIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M3 5.547 10.734 4.5V11.25H3V5.547zm0 12.703 7.734 1.031V12.75H3v5.5zm9.984 1.266L21 20.25V12.75h-8.016v6.766zm0-14.062L21 3.75v7.5h-8.016V5.454z" />
        </SvgIcon>
    );
}
